import { render, staticRenderFns } from "./MarketProductTableVariantImage.vue?vue&type=template&id=5e61fc0c&"
import script from "./MarketProductTableVariantImage.vue?vue&type=script&lang=js&"
export * from "./MarketProductTableVariantImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports